import { useAuth, useAppSelector } from '@verantos-dev/core-annotation-tool';

import { useGetAnnotationEncountersQuery } from '../api/annotatorQueueApiSlice';
import { selectBatchId, selectProjectId } from '../state/selector';

export const useAnnotationTaskDataGridFetch = (
  _searchParams?: string
): ReturnType<typeof useGetAnnotationEncountersQuery> => {
  const projectId = useAppSelector(selectProjectId);
  const batchId = useAppSelector(selectBatchId);
  const { user } = useAuth();

  return useGetAnnotationEncountersQuery(
    {
      projectId: projectId || '',
      batchId: batchId || '',
    },
    {
      skip: !user.isUser || !projectId || !batchId,
      refetchOnMountOrArgChange: true,
      refetchOnFocus: true,
    }
  );
};
